import { useQuery } from "convex/react";
import { useAuthIdentity } from "@/contexts/UserProfileContext";
import { api } from "@/lib/convexApi";
import { formatCurrency } from "@/lib/format";
import { CreditKeyPanelBoundary } from "./CreditKeyPanelBoundary";

export function CreditKeyCaptureQueue() {
  const identity = useAuthIdentity();
  if (identity.userRole !== "admin" || !identity.isAuthBridgeReady || !identity.isConvexAuthenticated) return null;
  return <CreditKeyPanelBoundary><AuthorizedCaptureQueue /></CreditKeyPanelBoundary>;
}

function AuthorizedCaptureQueue() {
  const rows = useQuery(api.creditKey.getCaptureQueue, {}) as Array<{
    attemptId: string; orderId: string; orderNumber: string; amount: number; environment: "sandbox" | "production";
  }> | undefined;
  if (!rows?.length) return null;
  return <details className="mb-4 rounded-lg border border-amber-200 bg-amber-50 p-3" open>
    <summary className="cursor-pointer text-sm font-semibold">Credit Key · {rows.length} shipped {rows.length === 1 ? "order needs" : "orders need"} capture</summary>
    <p className="mt-1 text-xs text-muted-foreground">Review the shipment and capture its authorized payment.</p>
    <ul className="mt-2 space-y-1 text-sm">
      {rows.map(row => <li key={row.attemptId} className="flex flex-wrap items-center justify-between gap-2">
        <span>{row.orderNumber}{row.environment === "sandbox" ? " · Test" : ""} · <strong>{formatCurrency(row.amount)}</strong></span>
        <a className="font-medium underline underline-offset-4 hover:text-primary" href={`/invoice/${row.orderId}`}>Review payment</a>
      </li>)}
    </ul>
  </details>;
}
